var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagApy = function SvgTagApy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 16,
    rx: 8,
    fill: "#AFAFAF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.601 10.512H7.457L6.953 12H4.805l3.048-8.424h2.376L13.277 12h-2.172l-.504-1.488Zm-.528-1.584L9.03 5.844 7.997 8.928h2.076Zm10.552-2.64c0 .488-.112.936-.336 1.344-.224.4-.568.724-1.032.972-.464.248-1.04.372-1.728.372h-1.272V12h-2.052V3.576h3.324c.672 0 1.24.116 1.704.348.464.232.812.552 1.044.96.232.408.348.876.348 1.404Zm-3.252 1.056c.392 0 .684-.092.876-.276.192-.184.288-.444.288-.78s-.096-.596-.288-.78c-.192-.184-.484-.276-.876-.276h-1.116v2.112h1.116Zm11.544-3.768-2.916 5.64V12H23.95V9.216l-2.916-5.64h2.328l1.632 3.528 1.62-3.528h2.304Z",
    fill: "#fff"
  })));
};
export default SvgTagApy;